import { useEffect } from "react";
import { loadRecaptcha } from "@/utils/recaptcha";

/**
 * Preloads the reCAPTCHA v3 script so the ~300ms script fetch does not land on
 * the submit button. Attaching the token is the Apollo link's job (see
 * RECAPTCHA_ACTION_BY_OPERATION), so this is an optimisation, not a
 * requirement - a guarded mutation still works on a page that never calls it.
 *
 * No-op when VITE_RECAPTCHA_SITE_KEY is unset (local dev / kill switch).
 */
function useRecaptcha() {
  useEffect(() => {
    loadRecaptcha();
  }, []);
}

export default useRecaptcha;
